/* ============================================================
   tio-why.js — "¿Por que un decant?" (T-32)
   Port de home-frame.html · funcion WhyDecant + useInView.

   El JS NO genera contenido. Las 4 razones y los 2 chips de precio ya
   vienen completos del servidor (SEO, Home.spec.md §SECCIONES 3b): aca
   solo se agrega lo que el navegador no da solo.

   1) DESLIZAR EN MOVIL = scroll-snap NATIVO. Cero JS en el touch, por eso
      conserva el momentum de iOS y nunca se come un gesto vertical.
   2) ARRASTRE CON MOUSE (pointerType 'mouse'): scrollLeft directo, .is-drag
      apaga el snap durante el arrastre y al soltar re-snapa suave al
      circulo mas cercano. En >=900px el rail es grid (scrollWidth ==
      clientWidth) y el arrastre no se activa.
   3) DOTS que siguen el scroll (listener pasivo, solo estado visual).
   4) REVELADO ESCALONADO gated (doctrina anti-flash C4 §7):

      La CSS congelada esconde con `.why:not(.is-inview) ... { opacity: 0 }`,
      es decir el estado OCULTO es el que llega por defecto. Portado tal
      cual seria un cartel en blanco si el JS no corre. Por eso el servidor
      emite la seccion YA con `is-inview` (estado final = estado base) y es
      este JS el que "arma" el reveal: le quita la clase SOLO si la seccion
      esta fuera del viewport (nadie la esta mirando) y se la devuelve al
      entrar. Sin JS, con JS roto o bloqueado: todo visible.

   Igual que el diseno usa listener PASIVO de scroll y no
   IntersectionObserver (no dispara dentro de iframes anidados; el editor
   de temas es uno).

   Doctrina 8.1: listeners DELEGADOS en document/window. El editor de temas
   re-renderiza la seccion entera y los handlers por elemento morirían con
   el nodo.
   ============================================================ */
(function () {
  'use strict';

  var SEL_SEC = '[data-tio-why]';
  var SEL_RAIL = '[data-tio-why-rail]';
  var SEL_DOT = '[data-tio-why-dot]';

  /* Mismo umbral que useInView del diseno: 85% del alto de la ventana. */
  var UMBRAL = 0.85;

  function menosMovimiento() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function cercano(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /* ---------------- Rail de circulos ---------------- */

  /* Indice del circulo cuyo centro esta mas cerca del centro del rail. */
  function indiceCentrado(rail) {
    var hijos = rail.children;
    if (!hijos.length) return 0;
    var centro = rail.scrollLeft + rail.clientWidth / 2;
    var mejor = 0;
    var mejorD = Infinity;
    for (var i = 0; i < hijos.length; i++) {
      var d = Math.abs(hijos[i].offsetLeft + hijos[i].offsetWidth / 2 - centro);
      if (d < mejorD) { mejorD = d; mejor = i; }
    }
    return mejor;
  }

  function centrar(rail, hijo) {
    var destino = hijo.offsetLeft - (rail.clientWidth - hijo.offsetWidth) / 2;
    if (rail.scrollTo) {
      rail.scrollTo({ left: destino, behavior: 'smooth' });
    } else {
      rail.scrollLeft = destino;
    }
  }

  function pintarDots(rail) {
    var sec = cercano(rail, SEL_SEC);
    if (!sec) return;
    var dots = sec.querySelectorAll(SEL_DOT);
    if (!dots.length) return;
    var activo = indiceCentrado(rail);
    for (var i = 0; i < dots.length; i++) {
      if (i === activo) {
        dots[i].classList.add('is-on');
      } else {
        dots[i].classList.remove('is-on');
      }
    }
  }

  /* El scroll no burbujea: se escucha en fase de captura, pasivo. */
  document.addEventListener('scroll', function (e) {
    var el = e.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-tio-why-rail')) return;
    pintarDots(el);
  }, { capture: true, passive: true });

  /* Tap en un dot: lleva el circulo de esa razon al centro. */
  document.addEventListener('click', function (e) {
    var dot = cercano(e.target, SEL_DOT);
    if (!dot) return;
    var sec = cercano(dot, SEL_SEC);
    if (!sec) return;
    var rail = sec.querySelector(SEL_RAIL);
    if (!rail) return;
    var i = parseInt(dot.getAttribute('data-tio-why-dot'), 10);
    if (isNaN(i)) i = 0;
    var hijo = rail.children[i];
    if (hijo) centrar(rail, hijo);
  });

  /* ---------------- Arrastre con MOUSE ----------------
     Solo mouse: el tactil sigue 100% nativo (snap + inercia del sistema). */
  var arrastre = null;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') return;
    var rail = cercano(e.target, SEL_RAIL);
    if (!rail) return;
    /* En >=900px el rail es un grid: no hay nada que arrastrar. */
    if (rail.scrollWidth <= rail.clientWidth) return;
    arrastre = { rail: rail, x: e.clientX, left: rail.scrollLeft, movido: false };
    rail.classList.add('is-drag');
  }, { passive: true });

  document.addEventListener('pointermove', function (e) {
    if (!arrastre) return;
    var dx = e.clientX - arrastre.x;
    if (Math.abs(dx) > 4) arrastre.movido = true;
    arrastre.rail.scrollLeft = arrastre.left - dx;
  }, { passive: true });

  function soltar() {
    if (!arrastre) return;
    var a = arrastre;
    arrastre = null;
    a.rail.classList.remove('is-drag');
    if (!a.movido) return;
    /* Re-snap suave al circulo mas cercano al soltar. */
    var hijo = a.rail.children[indiceCentrado(a.rail)];
    if (hijo) centrar(a.rail, hijo);
  }

  document.addEventListener('pointerup', soltar, { passive: true });
  document.addEventListener('pointercancel', soltar, { passive: true });

  /* ---------------- Revelado escalonado (gated) ---------------- */

  function enVista(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * UMBRAL && r.bottom > 0;
  }

  /* Candado anti-flash: basta UN pixel de la seccion en pantalla para que no
     se arme. No alcanza con "todavia no llego al 0.85": entre 0.85 y 1.0 del
     alto de la ventana la seccion YA asoma (el titulo y su subrayado a lapiz
     estan pintados) y quitarle is-inview ahi borraria un trazo que el usuario
     esta viendo. El umbral de ENTRADA sigue siendo el 0.85 del diseno; esto
     solo decide sobre que se permite crear el estado oculto (C4 §7). */
  function tocaViewport(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  /* Secciones ya armadas que esperan entrar en viewport. Mientras la lista
     este vacia el listener de scroll no toca el DOM (sale en la 1a linea). */
  var pendientes = [];

  /* "Armar" = crear el estado oculto, que NUNCA llega del servidor. Solo se
     arma lo que esta fuera de pantalla: lo que ya se ve no parpadea jamas. */
  function armar(sec) {
    if (sec.getAttribute('data-tio-why-armado')) return;
    sec.setAttribute('data-tio-why-armado', '1');
    if (menosMovimiento()) return;   /* en reduce la CSS no esconde nada */
    if (tocaViewport(sec)) return;   /* asoma aunque sea un pixel: no se toca */
    sec.classList.remove('is-inview');
    pendientes.push(sec);
  }

  function revisar() {
    if (!pendientes.length) return;
    var quedan = [];
    for (var i = 0; i < pendientes.length; i++) {
      var sec = pendientes[i];
      /* nodo reemplazado por el editor de temas: se descarta */
      if (!document.contains(sec)) continue;
      if (enVista(sec)) {
        sec.classList.add('is-inview');
      } else {
        quedan.push(sec);
      }
    }
    pendientes = quedan;
  }

  /* OJO: aca NO se repintan los dots. El rail arranca en scrollLeft 0 con el
     primer circulo pegado al borde izquierdo, pero el centro del rail cae
     entre el 1o y el 2o: la formula de proximidad al centro (la del diseno)
     devolveria el indice 1 y el punto activo saltaria al segundo apenas
     corre el JS. El diseno arranca su estado en 0 y solo lo mueve al hacer
     scroll; el servidor ya imprime el primer dot con is-on. Se respeta. */
  function iniciar() {
    var secs = document.querySelectorAll(SEL_SEC);
    for (var i = 0; i < secs.length; i++) armar(secs[i]);
    revisar();
  }

  window.addEventListener('scroll', revisar, { passive: true });
  window.addEventListener('resize', iniciar, { passive: true });
  /* Las imagenes de arriba (lazy) pueden correr la seccion hacia arriba
     DESPUES de armarla y meterla en pantalla sin que haya un scroll: sin
     esto se quedaria oculta para siempre. Revisar en 'load' lo cierra. */
  window.addEventListener('load', revisar, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* El editor de temas re-monta la seccion al cambiar un setting: el nodo
     nuevo llega otra vez con is-inview y se vuelve a armar. */
  document.addEventListener('shopify:section:load', iniciar);
})();
